<template>
    <Spinner v-if="isLoading" />
	<div class="grid nested-grid">

		<div class="col-12">								
			<div class="card fluid cardheader">
				<div class="col-12">
					<h5 class="stationsHeader">OCPI PARAMETRI</h5> 
				</div>												
			</div>	
        </div>

		<div class="col-12">												
            <div class="grid nested-grid ocpiplaceholder">
                <div class="col-2">OCPI URL</div>
                <div class="col-10">{{ publicPathOcpi }}/ocpi/versions</div>

                <div class="col-2">OCPI NAP žeton</div>
                <div class="col-10">{{ ocpiServerToken }}</div>
            </div>
        </div>     
        
        <div class="col-12 ocpiinitiategroup" v-if="isMinisterstvo && !ocpiRegistered">
            <div>
                
                <div class="grid nested-grid ocpiplaceholder">
                    <div class="col-12 handshaketitle">OCPI inicializacija še ni bila opravljena!</div>
                    <div class="col-12 handshakedesc">Vnesite URL od OCPI serverja ter OCPI žeton, ki Vam ga je posredovalo podjetje in kliknite "SPROŽI POVEZAVO"</div>
                    <div class="col-2"><Label>OCPI URL podjetja</Label></div>
                    <div class="col-10"><InputText type="text" v-model="clientOcpiUrl" /></div>
                    
                    <div class="col-2"><Label>OCPI žeton podjetja</Label></div>
                    <div class="col-10"><InputText type="text" v-model="clientOcpiToken" /></div>
                    
                    <div class="col-12 ocpiinitiateplaceholder"><Button icon="pi pi-cloud-upload" :disabled="isReadOnly" class="p-button-rounded p-button-info lockremovesite" @click="initiatehandshake" label="SPROŽI POVEZAVO" />	</div>
                </div>
            </div>
        </div>

        <div class="col-12 ocpiinitiategroup" v-if="isMinisterstvo && ocpiRegistered">
            <div>                
                <div class="grid nested-grid ocpiplaceholder">
                    <div class="col-12 handshaketitle">Iniciranje sinhronizacije infrastrukture</div>
                    <div class="col-12 handshakedesc">S klikom na gumb "SINHRONIZIRAJ" se zažene sinhronizacija infrastrukture</div>
                    
                    <div class="col-12 ocpiinitiateplaceholder"><Button icon="pi pi-cloud-upload" :disabled="isReadOnly" class="p-button-rounded p-button-info lockremovesite" @click="synchronizeinfrastructure" label="SINHRONIZIRAJ" />	</div>
                </div>
            </div>
        </div>        
    </div>

</template>

<script>

import { computed } from "vue";
import createHttp from "@/services/http";
import store from "@/store";
import Spinner from "@/components/Spinner.vue"


export default {
    components: { Spinner },    
    props: ['companyid'],
    data() {
        return {
            publicPath: process.env.BASE_URL,
            publicPathOcpi: process.env.VUE_APP_API_ROOT_FOLDER,
            ocpiServerToken:'',
            ocpiClientToken:'',
            clientOcpiToken:'',
            clientOcpiUrl:'',
            ocpiRegistered: false,
            ocpiVersion: '',
            isLoading: true,
            translated: computed(() => store.getters.getTranslate)
        }
    },    
    computed: {
        isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
        },
        isReadOnly() {
            return this.$store.getters.isInRole("ReadOnly");
        },        
        getCompanyId() {
            return this.companyid;
        }
    },

    
    async mounted() {
        console.log('MOUNTED DataConnections CONTROL !!!!', this.companyid);
        this.ocpiServerToken = '';

        var paramString = "?loadCompanyId=" + this.companyid;
        const http = createHttp(true); 
        const result = await http.get(process.env.VUE_APP_API_FOLDER + "/GetCompanyOCPIToken" + paramString);


        if(result.status==200){
            console.log('Prejel OCPIToken: ' + result.data);
            this.ocpiServerToken = result.data.servertoken;
            this.ocpiClientToken = result.data.clienttoken;
            this.ocpiRegistered = result.data.registered;
            this.ocpiVersion = result.data.ocpiversion;
            // this.energysites = result.data
        } else {
            console.log('Napaka pri pridobivanju OCPITokena');
            this.ocpiServerToken = '';
        }
    },    
    
    async created() {
        // console.log('KLIČEM CREATED MDashboard.vue CONTROL !!!!', this.$store.getters.getRole, this.companyid);
        //console.log(this.companyid);        
        // this.paramCompanyId = this.companyid;        

        //console.log('Pred Load Data');
        await this.loadData();
        //console.log('Konec LOAD DATA');

        
    }, 
    methods: {

        getVersionRecord(versions, versionToFind) {
            return versions.find(v => v.version === versionToFind) ?? null;
        },  

        async synchronizeinfrastructure() {
            this.isLoading = true;

            try {
                console.log('KLIČEM SYNCHRONIZE INFRASTRUCTURE');
            
                var ocpiUrl = process.env.VUE_APP_API_FOLDER + '/StartSynchronization';
                var postParam = {
                    Version: this.ocpiVersion,
                    Token: this.ocpiClientToken
                };

                const http = createHttp(true); 
                const response = await http.post(ocpiUrl, postParam);
                
                console.log('SYNCHRONIZE RESPONSE:', response);

                if(response.status==200) {                
                    console.log('Sinhronizacija uspešna', response.data);
                } else {                
                    console.log('Sinhronizacija ni uspela', response);
                }
            } catch (error) {
                console.error('Napaka pri sinhronizaciji infrastrukture:', error);                
            } finally {
                this.isLoading = false;
            }

        },

        async initiatehandshake() {
            console.log('KLIČEM INITIATE HANDSHAKE');

            if(this.clientOcpiUrl.length==0 || this.clientOcpiToken.length==0) {
                this.$toast.add({severity:'error', summary: 'Napaka', detail: 'Vnesite URL in žeton podjetja', life: 3000});
                return;
            }

            const myToken = `Token ${this.clientOcpiToken}`;

            console.log('INITIATE HANDSHAKE', myToken);

            const http = createHttp(true, myToken); 
            const response = await http.get(this.clientOcpiUrl);

            if(response.status==200) {
                this.$toast.add({severity:'success', summary: 'Uspeh', detail: 'Povezava uspešno sprožena', life: 3000});
                console.log('Povezava uspešno sprožena', response.data.data);
                
                // 1) Using optional chaining + a length check
                if (response.data?.data?.length > 0) {
                    // data is not null/undefined and has at least one element
                    console.log('Got:', response.data.data)
                    var ver230 = this.getVersionRecord(response.data.data, '2.3.0');
                    var ver211 = this.getVersionRecord(response.data.data, '2.1.1');

                    var ocpiHandshakeUrl = this.publicPathOcpi + '/ocpi/';                    
                    var ocpiHandshakeObj = null;
                    if(ver230) {                        
                        ocpiHandshakeUrl += '2.3.0/initiatehandshake'; 
                        ocpiHandshakeObj = {
                            token: this.clientOcpiToken,
                            url: this.clientOcpiUrl,
                            hub_party_id: "001",
                            roles: [{
                                role: "CPO",
                                party_id: "007",
                                country_code: "SI",
                                business_details: {
                                    name: "string"
                                }
                            }],
                        }; 
                                            
                    } else if(ver211) {
                        ocpiHandshakeUrl += '2.1.1/initiatehandshake';
                        ocpiHandshakeObj = {
                            token: this.clientOcpiToken,
                            url: this.clientOcpiUrl,
                            business_details: {
                                name: "string"
                            },
                            party_id: "007",
                            country_code: "si"
                        };  

                    } else {
                        ocpiHandshakeUrl = '';
                    }
                    console.log('OCPI HANDSHAKE URL:', ocpiHandshakeUrl);
                    
                    if(ocpiHandshakeUrl.length > 0) {
                        // Pokličem NAP server za handshake
                        const myTokenServer = `Token ${this.ocpiServerToken}`;
                        const httpHandshake = createHttp(true, myTokenServer); 
                        const responseHandshake = await httpHandshake.post(ocpiHandshakeUrl, ocpiHandshakeObj);
                        if(responseHandshake.status==200) {
                            console.log('OCPI HANDSHAKE RESPONSE:', responseHandshake.data);    
                            this.ocpiRegistered = true;                        
                        } else {
                            console.log('OCPI HANDSHAKE RESPONSE ERROR:', responseHandshake);
                        }
                    }

                } else {
                    // data is null/undefined or an empty array
                    console.log('No data')
                }

            } else {
                this.$toast.add({severity:'error', summary: 'Napaka', detail: 'Povezava ni uspela', life: 3000});
            }
        },

        async loadData() {
                
            this.isLoading = false;
        }
    }
}
</script>

<style scoped>

.ocpiplaceholder {margin-left: 20px;}
.ocpiinitiateplaceholder {display: flex;justify-content: end;}
.ocpiinitiategroup {margin-top: 20px; margin-bottom: 20px; padding: 10px; background-color: #e1e1e1; border-radius: 5px;}
.handshaketitle {font-weight: bold; font-size: 1.2em; margin-bottom: 10px;}
.handshakedesc {margin-bottom: 20px; font-size: 0.9em; color: #555;}
</style>